
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0a44"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0a44"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $7e5efeb177ac9dba$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["auyDg","index.a8d6c721.js","iZDw6","cyberalarm_logo_white.427e683c.png","90bqv","nis2.0e54974d.png","35Bw3","training-platform-screenshot.a3b0cf9b.png","6KQuR","management-platform-screenshot.a77c235c.png","igwbW","Deutsche_Bank-Logo.svg.2767138e.png","778Py","university_hospital_dusseldorf_Logo.svg.0b6897d3.png","gfx5W","logo-hamburgische-buergerschaft.0f653571.png","enuTG","landespolizei-brandenburg.ea548c97.webp","4z0qu","logo-cybersicherheitsrat.db48e651.png","6TvW7","gamebook-services-logo-blue.77ad20e8.png","g4ROZ","ALARM-Partner.569bcb9b.png","1uhEc","Foto-Awarenes-Forum.410c8747.png","2aAz5","German_Map_DE.7baed562.png","cFJgB","edeka_logo.f1cae688.png","lnwcl","GismaLogo.78f0b894.png","498iX","RVLogoV2.fdb4e380.png","hu5pJ","tb&a_logo.6db9e1af.png","38bzC","phishing.bfab6c80.jpg","dgAdH","ceoFraud.37ddebf4.jpg","3cqWm","ransomware.2135261f.png","cg5JX","secureTravel.4dd7f950.jpeg","cS2JQ","socialEngineering.9efaa41c.jpeg","04wWh","dataProtection.908bb526.jpeg","cvfh0","messenger.cb61543c.jpg","jiK2B","training_img1.d99f66f3.png","hTVbC","training_img2.186a0576.png","4uNfl","training_img3.ff62f12e.png","BEcVa","landingPageManagingDirector.d5d648bb.png","9spwB","LandingPageITManager.4f083792.png","2WbW8","certificatePreview.547e5de1.png","82kA8","ResetPasswordView.68e3262d.js","2qBbj","RenewPasswordView.42c4d2a8.js","ia96m","DashboardView.ab59da44.js","5j5Gk","DashboardView.8ae1c423.js","hH7d5","EmployeesView.880402e2.js","eveBQ","EmployeesView.0591c2f3.js","cwzsY","CompanyAnalyticsView.9d7fcd95.js","aD9MA","CompanySeatsView.39576998.js","eiB8M","CompanySeatsView.dd05d578.js","kUa44","CompanySubscriptionView.59d91f70.js","jHoFG","CompanySubscriptionView.3c66b87f.js","f7AoK","CompanyInvoicesView.3a753f8c.js","6GKMl","CompanyDetailsView.232aa92c.js","gdTQa","CourseOverview.1f0e45c8.js","2jWiT","CourseOverview.93970282.js","8kb9x","EmployeeCourseOverview.cd980452.js","kPrXt","AccountSubscriptionView.632e4d89.js","ecW3v","AccountPaymentsView.64715952.js","1pGvm","AccountDetailsView.5feb2eef.js","jxpww","UpgradeSubscriptionComponent.be7165bc.js","kHmfS","VerifyCertificateView.7abfa5c5.js","8koGT","index.0ed9da48.css"]'));


//# sourceMappingURL=index.runtime.724efbb4.js.map
